import { 
    apiBizInsertContract,
    apiBizInsertContractIdImg,
    apiBizInsertContractFile,
    apiBizGetContractPeriod
} from "@/apis/api.js"; 
import { 
    paperContractNotification
    } from "@/apis/company/leaseMgt.js"; 
import router from '@/router'

const defaultContractData = {
    "tenantName" : null,
    "tenantPhone" : null,
    "tenantIdNumber" : null,
    "contractBeginTime" : null,
    "contractEndTime" : null,
    "tenantNumber" : null,
}
const defaultIdentification = {
    font: [],
    back: []
}
const defaultDatePeriod = {
    contractPeriod: [],
}
const defaultSelectedHouseInfo = {
    seleted: null,
    houseCid: null,
    houseName: null,
    rent: 0,
    address: null,
    houseStatus: null,
    moveInDate: null,
    contractPeriod: [],
    agentName: null
}
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_contract_id: 'bizNewContract/set_contract_id',
    set_contract: 'bizNewContract/set_contract',
    set_contract_id_img: 'bizNewContract/set_contract_id_img',
    set_contract_paper: 'bizNewContract/set_contract_paper',
    set_contract_paper_type: 'bizNewContract/set_contract_paper_type',
    set_contract_status: 'bizNewContract/set_contract_status',
    set_upload_status: 'bizNewContract/set_upload_status',
    set_notify_status: 'bizNewContract/set_notify_status',
    set_contract_data: 'bizNewContract/set_contract_data',
    set_id_card_img: 'bizNewContract/set_id_card_img',
    set_date_period: 'bizNewContract/set_date_period',
    set_selected_house: 'bizNewContract/set_selected_house',
    set_default: 'bizNewContract/set_default',
    set_available_house: 'bizNewContract/set_available_house',
    set_contract_period: 'bizNewContract/set_contract_period',
}

// count state 必須是 Object
const state = {
    contractId: null,
    contractStatus: 1,
    contractPaperType: null,
    contract: [],
    identification: [],
    contractPaper: [],
    uploadStatus: {
        status: false,
        msg: null,
    },
    notifyStatus: {
        status: false,
        msg: null,
    },
    contractData: Object.assign({}, defaultContractData),
    identification: Object.assign({}, defaultIdentification),
    datePeriod: Object.assign({}, defaultDatePeriod),
    selectedHouseInfo: Object.assign({}, defaultSelectedHouseInfo),
    availableHouseList: [],
    contractPeriod: []
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_CONTRACT_STATUS: (state) => {
        return state.contractStatus
    },
    GET_BIZ_UPLOAD_STATUS: (state) => {
        return state.uploadStatus
    },
    GET_BIZ_NOTIFY_STATUS: (state) => {
        return state.notifyStatus
    },
    GET_BIZ_CONTRACT_DATA: (state) => {
        return state.contractData
    },
    GET_BIZ_CONTRACT_IDENTIFICATION: (state) => {
        return state.identification
    },
    GET_BIZ_CONTRACT_DATE_PERIOD: (state) => {
        return state.datePeriod
    },
    GET_BIZ_CONTRACT_SELECTED_HOUSE: (state) => {
        return state.selectedHouseInfo
    },
    GET_BIZ_CONTRACT_AVAILABLE_HOUSE: (state) => {
        return state.availableHouseList
    },
    GET_BIZ_CONTRACT_PERIOD: (state) => {
        return state.contractPeriod
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizGetContractPeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetContractPeriod(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    console.log('apiBizGetContractPeriod',res.data.result)
                    commit(types.set_contract_period, res.data.result);
                    
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizNewContractId ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id, data);
            resolve()
        })
    },
    setBizNewContract ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract, data);
            resolve()
        })
    },
    setBizNewContractIdImg ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id_img, data);
            resolve()
        })
    },
    setBizNewContractPaper ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_paper, data);
            resolve()
        })
    },
    setBizNewContractPaperType ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_paper_type, data);
            resolve()
        })
    },
    saveBizNewContract ( {commit, dispatch, state} , action) {
        return new Promise((resolve, reject) => {
            dispatch('setLoadingState', 1)
            // state.contract.dash = parseInt(state.contract.dash)
            let data = state.contract
            apiBizInsertContract(data)
            .then(res => {
                console.log(res)
                // console.log(state.identification)
                console.log('儲存合約基本資料')
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_id, res.data.result.paperContractCid)
                    // console.log('success')
                    // console.log(state.identification)
                    if(state.identification.back && state.identification.font && state.identification.back.length > 0 && state.identification.font.length > 0){
                        console.log('有身分證檔案')
                        dispatch('saveBizNewContractIdImg').then( () => {
                            console.log('打上傳身分證ＡＰＩ')
                            if( action == 1){
                                
                                dispatch('saveBizNewContratFile', 1)
                              
                                resolve()
                            }else{
                                dispatch('saveBizNewContratFile', 0)
                                // dispatch('setLoadingState', 0)
                                // commit(types.set_contract_status, 3)
                                resolve()
                            }
                        })
                    }else{
                        if( action == 1){
                            dispatch('saveBizNewContratFile', 1)
                            resolve()
                        }else{
                            dispatch('saveBizNewContratFile', 0)
                            resolve()
                        }
                    }
                    
                }else{
                    commit(types.set_contract_status, 1)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    dispatch('setLoadingState', 0)

                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    saveBizNewContractIdImg ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            console.log(state.identification.font[0].file)
            console.log(state.identification.back[0].file)
            let formData = new FormData();
                formData.append('frontSide', state.identification.font[0].file);
                formData.append('backSide', state.identification.back[0].file);
                formData.append('paperContractCid', state.contractId);
            apiBizInsertContractIdImg(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    commit(types.set_contract_status, 1)
                    dispatch('setLoadingState', 0)

                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    saveBizNewContratFile ( {commit, state, dispatch}, action ) {
        return new Promise((resolve, reject) => {
            dispatch('setLoadingState', 1)
            if( state.contractPaperType == "pdf" ){
                // console.log(state.contractPaper[state.contractPaper.length-1].file)
                let formData = new FormData();
                    formData.append('document', state.contractPaper[state.contractPaper.length-1].file);
                    formData.append('paperContractCid', state.contractId);
                    formData.append('page', '');
                apiBizInsertContractFile(formData)
                .then(res => {
                    // console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        if( action == 1){
                            dispatch('setLoadingState', 0)
                                dispatch('bizSetNewContractDefault')
                                router.push({name: 'bizLeaseMgtDefault', hash: '#紙本確認中'})
                                dispatch('setAlarmStatus', {status: true,title: '成功新增紙本合約',description: '您尚未通知房客，可以另外通知房客進行合約確認',type: 'success'})
                                // window.location.href = '/landlord/leasemanagement/home?success=1'
                            resolve()
                        }else{
                            dispatch('bizNotifyTanant').then( () => {
                                resolve()
                            })
                        }
                        resolve()
                    }else{
                        dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                        commit(types.set_contract_status, 1)
                        dispatch('setLoadingState', 0)
                    }
                })
                .catch(err => {
                    dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                    reject(err)
                })
            }else if( state.contractPaperType == "image" ){
                for (let i = 0; i < state.contractPaper.length; i++) {
                    const element = state.contractPaper[i];

                    let formData = new FormData();
                    formData.append('document', element.file);
                    formData.append('housesCid', state.contractId.housesTemporaryCid);
                    formData.append('page', i+1);
                    apiBizInsertContractFile(formData)
                    .then(res => {
                        // console.log(res)
                        if( res.data.status == "SUCCESS" ){
                            if( action == 1){
                                dispatch('setLoadingState', 0)
                                router.push({name: 'bizLeaseMgtDefault', hash: '#紙本確認中'})
                                // window.location.href = '/landlord/leasemanagement/home?success=1'
                                resolve()
                            }else{
                                dispatch('bizNotifyTanant').then( () => {
                                    commit(types.set_contract_status, 3)
                                    dispatch('setLoadingState', 0)
                                    resolve()
                                })
                            }
                        }else{
                            dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})

                        }
                    })
                    .catch(err => {
                        dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})

                        reject(err)
                    })
                }
            }
            
        })
    },
    bizNotifyTanant ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            let data = {
                paperContractCid: state.contractId
            }
            paperContractNotification(data)
            .then(res => {
                // console.log(res)
                console.log('打通知租客ＡＰＩ')

                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_status, 3)
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: '通知租客成功',type: 'success'})

                    resolve()
                }else{
                    commit(types.set_contract_status, 1)
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    bizSetNewContractStatus ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_status, data)
        })
    },
    bizSetNewContractData ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_data, data)
        })
    },
    bizSetNewContractIdentification ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_id_card_img, data)
        })
    },
    bizSetNewContractDatePeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_date_period, data)
        })
    },
    bizSetNewContractSelectedHouse ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_selected_house, data)
        })
    },
    bizSetNewContractDefault ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_default)
        })
    }
}

// mutations
const mutations = {
    [types.set_contract_id](state, data){
        state.contractId = data
    },
    [types.set_contract](state, data){
        state.contract = data
    },
    [types.set_contract_period](state, data){
        state.contractPeriod = data
    },
    [types.set_contract_id_img](state, data){
        state.identification = data
    },
    [types.set_contract_paper](state, data){
        state.contractPaper = data
    },
    [types.set_contract_paper_type](state, data){
        state.contractPaperType = data
    },
    [types.set_contract_status](state, data){
        state.contractStatus = data
    },
    [types.set_upload_status](state, data){
        state.uploadStatus = data
    },
    [types.set_notify_status](state, data){
        state.notifyStatus = data
    },
    [types.set_contract_data](state, data){
        state.contractData = data
    },
    [types.set_id_card_img](state, data){
        state.identification = data
    },
    [types.set_date_period](state, data){
        state.datePeriod = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouseInfo = data
    },
    [types.set_available_house](state, data){
        state.availableHouseList = data
    },
    [types.set_default](state, data){
        state.contractStatus = 1
        state.contractData = Object.assign({}, defaultContractData)
        state.identification = Object.assign({}, defaultIdentification)
        state.datePeriod = Object.assign({}, defaultDatePeriod)
        state.selectedHouseInfo = Object.assign({}, defaultSelectedHouseInfo)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/newContract.js